module.exports = __webpack_public_path__ + "0acec6369a34bd02cb3031a3c4fee9ae.jpg";